import type {
  CutConfig, MarginsConfig, OutputConfig, PaperConfig, SignConfig, TileConfig, ViewMode,
} from "../domain/types";

export const DEFAULT_PAPER: PaperConfig = {
  preset: "A4",
  width: 210,
  height: 297,
  orientation: "portrait",
};

export const DEFAULT_MARGINS: MarginsConfig = {
  top: 10, right: 10, bottom: 15, left: 10,
  linked: false,
  preset: "standard",
};

export const DEFAULT_SIGN: SignConfig = {
  width: 0,
  height: 0,
  lockAspect: true,
};

export const DEFAULT_TILE: TileConfig = {
  auto: true,
  cols: 1,
  rows: 1,
};

export const DEFAULT_CUT: CutConfig = {
  enabled: false,
  thicknessMm: 0.2,
  style: "dashed",
};

export const DEFAULT_OUTPUT: OutputConfig = {
  dpi: 300,
};

export const DEFAULT_VIEW: ViewMode = "print";
